import React from 'react';
import PropTypes from 'prop-types';
import { MetadataPropTypesShape } from '@Components/Results/MetadataPropTypes';
import ResultCheckboxNew from '@Pages/Results/Containers/ResultCheckboxContainer';
import PatentContent from '@Containers/PatentFamilyClustering/Components/PatentContent';

function PatentFamilyMember({
  document,
  metadata,
  zoom,
  isMainFamilyMember,
  getTrackingAttrs,
  firstSectionExpanded,
  setFirstSectionExpanded,
}) {
  const { context } = metadata;

  return (
    <div className="patent-family-member">
      <ResultCheckboxNew result={document} context={context} />
      <PatentContent
        document={document}
        metadata={metadata}
        zoom={zoom}
        isMainFamilyMember={isMainFamilyMember}
        getTrackingAttrs={getTrackingAttrs}
        firstSectionExpanded={firstSectionExpanded}
        setFirstSectionExpanded={setFirstSectionExpanded}
      />
    </div>
  );
}

PatentFamilyMember.propTypes = {
  // Own props
  metadata: MetadataPropTypesShape,
  document: PropTypes.object.isRequired,
  zoom: PropTypes.number,
  // Set in parent
  isMainFamilyMember: PropTypes.bool,
  getTrackingAttrs: PropTypes.func.isRequired,
  firstSectionExpanded: PropTypes.bool,
  setFirstSectionExpanded: PropTypes.func,
};

export default PatentFamilyMember;
